// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_nv-0";